/* eslint-disable max-len */
import { PaletteNames, UITypes } from 'LibNeo'
import { FieldNames } from 'Constants/FieldNames'
import { RbidosRequestStatuses } from './orderEditStatuses'

export const infotecsStatuses = [
	RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
	RbidosRequestStatuses.S_CI_WAIT_PKCS10,
	RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
	RbidosRequestStatuses.S_EXECUTION,
	RbidosRequestStatuses.S_CI_COMPLETE,
	RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
	RbidosRequestStatuses.S_RBIDOS_CA_VALIDATION_COMPLETE,
]

export enum INFOTECS_STATUS_SLUG {
	COMPLETE = 'complete',
	WAIT_SCAN_UPLOAD = 'wait-scan-upload',
	CERTIFICATE_ISSUE = 'certificate-issue',
	WAIT_CONSUMER_IDENTIFICATION = 'wait-consumer-identification',
}

export enum SPOD_STATUS {
	PROCESSING = 'processing',
	SUCCESS = 'success',
	FAIL = 'fail',
	UNKNOW = 'unknow',
	FAILURE = 'failure',
	STILL_PROCESSING = 'still_processing',
}

export enum SPOD_SCAN {
	А1 = 'А1',
	C1 = 'C1',
	D1 = 'D1',
}

export enum SPOD_PHOTO {
	A1 = 'A1',
	B1 = 'B1',
	B2 = 'B2',
	B3 = 'B3',
	B4 = 'B4',
	B5 = 'B5',
	B6 = 'B6',
	B7 = 'B7',
	B8 = 'B8',
	C1 = 'C1',
	D1 = 'D1',
}

export const SPOD_PARAMS = {
	CERT: 0.8,
	SIGNS: 3,
}

export const mainCheckList = [
	{
		title: 'Я убедился в действительности даты выдачи паспорта и возраста клиента',
	},
	{ title: 'Я сверил фотографию в паспорте с личностью клиента' },
	{
		title: 'Я убедился, что отсутствуют признаки подделки паспорта',
		description: 'и проверил документ с помощью прибора с УФ-детектором (при наличии оборудования)',
	},
	{
		title: 'Я сверил подписи в паспорте с имеющимися/полученными образцами',
	},
]

export const SpodScanConfig: Record<
	SPOD_SCAN,
	{
		description: string
		color?: PaletteNames
		icon?: string
		type?: UITypes
	}
> = {
	[SPOD_SCAN.А1]: {
		description: 'Алгоритмы не выявили замечаний',
		color: 'gray',
		icon: 'robot',
		type: UITypes.PRIMARY,
	},
	[SPOD_SCAN.C1]: {
		description: 'Сертификат не распознан',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_SCAN.D1]: {
		description: 'Некорректное число подписей',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
}

export const SpodPhotoConfig: Record<
	SPOD_PHOTO,
	{
		description: string
		color: PaletteNames
		icon: string
		type: UITypes
	}
> = {
	[SPOD_PHOTO.A1]: {
		description: 'Алгоритмы не выявили замечаний',
		color: 'gray',
		icon: 'robot',
		type: UITypes.PRIMARY,
	},
	[SPOD_PHOTO.B1]: {
		description: 'На фото не найден сертификат',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B2]: {
		description: 'На фото найдено несколько документов',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B3]: {
		description: 'На фото не найден человек',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B4]: {
		description: 'На фото не найден человек и сертификат',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B5]: {
		description: 'На фото не найден человек, но обнаружено несколько документов',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B6]: {
		description: 'На фото найдено несколько людей',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B7]: {
		description: 'На фото найдено несколько людей без сертификата',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.B8]: {
		description: 'На фото найдено несколько людей и несколько документов',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.C1]: {
		description: 'Сертификат не распознан',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
	[SPOD_PHOTO.D1]: {
		description: 'Некорректное число подписей',
		color: 'gray',
		icon: 'info',
		type: UITypes.GREY,
	},
}

export const Spod: Record<
	SPOD_STATUS | string,
	{
		description: string
		color?: PaletteNames
		icon?: string
		type?: UITypes
	}
> = {
	[SPOD_STATUS.PROCESSING]: {
		description: 'Проверяем файл с помощью алгоритмов...',
		color: 'gray',
	},
	[SPOD_STATUS.STILL_PROCESSING]: {
		description: 'Проверка может занять несколько минут....',
		color: 'gray',
	},

	[SPOD_STATUS.FAILURE]: {
		description: 'Фото не распознано',
		color: 'pink',
		icon: 'attention',
		type: UITypes.DANGER,
	},
}

export enum TYPE_TITLE {
	SCAN = 'scan',
	PHOTO = 'photo',
}

export const translateSpodTitle = {
	[TYPE_TITLE.SCAN]: 'Скан подписанного сертификата КЭП ФЛ',
	[TYPE_TITLE.PHOTO]: 'Фотография клиента с подписанным сертификатом в руках',
}

export const SpodList = [
	{
		text: 'является сканом или фото сертификата',
	},
	{
		text: 'легко читается',
	},
	{
		text: 'содержит требуемые подписи сторон',
	},
]

export enum CA_CALLBACK_STATE {
	INVALID_PASSPORT = 'invalid_passport',
	INVALID_FULL_NAME_INN = 'invalid_full_name_inn',
	INVALID_FULL_NAME_SNILS = 'invalid_full_name_snils',
}

export const TIME_LIMIT = 30

export enum CA_CALLBACK_ERROR_MESSAGE {
	SNILS = 'СНИЛС не прошёл проверку на соответствие ФИО',
	INN = 'ИНН не прошёл проверку на соответствие ФИО',
	PASSPORT = 'Паспорт не прошёл проверку в МВД',
}
export enum GOVERNMENT_ORGANIZATIONS {
	PFR = 'ПФР',
	FNS = 'ФНС',
	MVD = 'МВД',
}
export interface CA_CALLBACK_ALL_ERROR {
	errorMessage: CA_CALLBACK_ERROR_MESSAGE
	governmentOrganization: GOVERNMENT_ORGANIZATIONS
}
export const caCallbackErrorsRequiredFields = {
	[GOVERNMENT_ORGANIZATIONS.FNS]: [
		FieldNames.FIO,
		FieldNames.PASSPORT_SERIES_NUMBER,
		FieldNames.PASSPORT_GIVEN_DATE,
		FieldNames.PASSPORT_ISSUE_CODE,
		FieldNames.INN,
	],
	[GOVERNMENT_ORGANIZATIONS.MVD]: [
		FieldNames.FIO,
		FieldNames.PASSPORT_SERIES_NUMBER,
		FieldNames.PASSPORT_GIVEN_DATE,
	],
	[GOVERNMENT_ORGANIZATIONS.PFR]: [
		FieldNames.FIO,
		FieldNames.GENDER,
		FieldNames.BIRTH_DATE,
		FieldNames.SNILS,
	],
}
